import {
    addEditManualEntryRecordsActionTypes,
    apiActionsManualEntryRecords, ManualEntryRecordActionTypes
} from "../constants/ManualEntryRecordsActionConstants";
import _ from "lodash";
import countriesData from "../../../common/resources/countries.json";
import MONTH_OPTIONS from "../../../common/resources/monthOptions.json";

const initialState = {
    orgTenantCountryObject: {},
    organizationsList: [],
    tenantsList: [],
    countriesList: countriesData,
    addNewRecordModalOpen: false,
    editRecordModalOpen: false,
    deleteBillingRecordWarning: false,
    billingRecordObject: {
        id: "",
        invoice_date: "",
        organization: "",
        tenant: null,
        country_code: null,
        billing_product: "",
        billing_period: "MONTHLY",
        billing_type: "INVOICE",
        item_description: "",
        item_quantity: 0,
        item_unit_price: 0.00,
        item_total: 0.00,
        manual_entry: 1,
        month: "",
    }
}

const AddEditBillingRecordsReducer = (state = initialState, action) => {
    switch (action.type) {

        case addEditManualEntryRecordsActionTypes.CLOSE_RECORDS_MODAL: {
            let newState = _.cloneDeep(state);
            const orgTenantsObj = newState.orgTenantCountryObject;
            newState = initialState;
            newState.addNewRecordModalOpen = false;
            newState.orgTenantCountryObject = orgTenantsObj;
            return newState;
        }

        case addEditManualEntryRecordsActionTypes.CLEAR_RECORDS_MODAL: {
            let newState = _.cloneDeep(state);
            const orgTenantsObj = newState.orgTenantCountryObject;
            newState = initialState;
            newState.addNewRecordModalOpen = true;
            newState.orgTenantCountryObject = orgTenantsObj;
            return newState;
        }

        case addEditManualEntryRecordsActionTypes.TOGGLE_ADD_RECORDS_MODAL: {
            let newState = _.cloneDeep(state);
            newState.organizationsList = [];
            newState.addNewRecordModalOpen = !newState.addNewRecordModalOpen;
            for (const k in newState.orgTenantCountryObject) {
                newState.organizationsList.push({
                    label: k,
                    value: k
                })
            }
            newState.billingRecordObject.month = action.payload;
            return newState;
        }

        case addEditManualEntryRecordsActionTypes.TOGGLE_EDIT_RECORDS_MODAL: {
            let newState = _.cloneDeep(state);
            newState.editRecordModalOpen = !newState.editRecordModalOpen;
            newState.billingRecordObject = action.payload;
            newState.organizationsList = [];

            const dateArray = action.payload.invoice_date.slice(0, 7).split("-");
            newState.billingRecordObject.month = _.find(MONTH_OPTIONS, { value: Number(dateArray[1])}).label
                + " " + dateArray[0];

            for (const k in newState.orgTenantCountryObject) {
                newState.organizationsList.push({
                    label: k,
                    value: k
                })
            }
            const associatedTenantsList = newState.orgTenantCountryObject[newState.billingRecordObject.organization];
            associatedTenantsList.split(",").forEach(t => {
                newState.tenantsList.push({
                    label: t,
                    value: t
                });
            });
            return newState;
        }

        case addEditManualEntryRecordsActionTypes.SET_ORG_TENANT_COUNTRIES: {
            let newState = _.cloneDeep(state);
            newState.organizationsList = [];
            newState.orgTenantCountryObject = action.payload;
            for (const k in newState.orgTenantCountryObject) {
               newState.organizationsList.push({
                   label: k,
                   value: k
               })
            }
            return newState;
        }

        case addEditManualEntryRecordsActionTypes.SET_BILLING_RECORDS_TYPE: {
            let newState = _.cloneDeep(state);
            if (action.payload.billingType !== null) {
                newState.billingRecordObject.billing_type = action.payload.billingType.value;
                newState.billingRecordObject.billing_product = "";
            } else {
                newState.billingRecordObject.billing_type = "";
            }
            return newState;
        }

        case addEditManualEntryRecordsActionTypes.SET_BILLING_RECORDS_PRODUCT: {
            let newState = _.cloneDeep(state);
            if (action.payload.billingProduct !== null) {
                newState.billingRecordObject.billing_product = action.payload.billingProduct.value;
            } else {
                newState.billingRecordObject.billing_product = "";
            }
            return newState;
        }

        case addEditManualEntryRecordsActionTypes.SET_BILLING_RECORDS_ORG:{
            let newState = _.cloneDeep(state);
            if (action.payload.org !== null) {
                newState.tenantsList = [];
                const selectedOrg = action.payload.org.value;
                newState.billingRecordObject.organization = selectedOrg;

                // data structure here is set as an object of k,v pair with k being org name and v
                // being as the list of associated tenants.
                const associatedTenantsList = newState.orgTenantCountryObject[selectedOrg];
                if (associatedTenantsList.length !== 0) {
                    associatedTenantsList.split(",").forEach(t => {
                        newState.tenantsList.push({
                            label: t,
                            value: t
                        });
                    });
                } else {
                    newState.tenantsList = [];
                }
            } else {
                newState.tenantsList = [];
                newState.billingRecordObject.organization = "";
            }
            return  newState;
        }

        case addEditManualEntryRecordsActionTypes.SET_BILLING_RECORDS_TENANT:{
            let newState = _.cloneDeep(state);
            if (action.payload.tenant !== null) {
                newState.billingRecordObject.tenant = action.payload.tenant.value;
            } else {
                newState.billingRecordObject.tenant = "";
            }
            return  newState;
        }

        case addEditManualEntryRecordsActionTypes.SET_BILLING_RECORDS_COUNTRY:{
            let newState = _.cloneDeep(state);
            if (action.payload.country !== null) {
                newState.billingRecordObject.country_code = action.payload.country.value;
            } else {
                newState.billingRecordObject.country_code = "";
            }
            return newState;
        }

        case addEditManualEntryRecordsActionTypes.SET_FORM_VALUE: {
            let newState = _.cloneDeep(state);
            if (action.payload !== null) {
                newState.billingRecordObject[action.payload.name] = action.payload.value;
            } else {
                newState.billingRecordObject[action.payload.name] = "";
            }
            return newState;
        }

        case apiActionsManualEntryRecords.DELETE_WARNING_FOR_RECORD: {
            let newState = _.cloneDeep(state);
            newState.deleteBillingRecordWarning = !newState.deleteBillingRecordWarning;
            // below attribute is not a part of the initialState. It is added and used only when the user attempts to
            // delete a particular record.
            newState.recordIDForDelete = action.payload;
            return newState;
        }

        case ManualEntryRecordActionTypes.CLEAR_MANUAL_BILLING_RECORDS: {
            return initialState;
        }

        default: return state
    }
}

export default AddEditBillingRecordsReducer;
